import React, { useContext } from 'react';

import { graphql } from 'gatsby';

// components
import Chart1Wrapper from './chart1Wrapper/chart1Wrapper';
import Chart2Wrapper from './chart2Wrapper/chart2Wrapper';
import Chart3Wrapper from './chart3Wrapper/chart3Wrapper';
import Chart4Wrapper from './chart4Wrapper/chart4Wrapper';
import ChartQuestions from './chartQuestions/chartQuestion';

import ChartHealth2Wrapper from './chartHealth2Wrapper/chartHealth2Wrapper';
import ChartHealth3Wrapper from './chartHealth3Wrapper/chartHealth3Wrapper';
import ChartHealth4Wrapper from './chartHealth4Wrapper/chartHealth4Wrapper';
import ChartHealth1Wrapper from './chartHealth1Wrapper/chartHealth1Wrapper';
import ChartQuestionsHealth from './chartQuestionsHealth/chartQuestionHealth';

// styles
import './chart.scss';

interface ChartProps {
  graphId: string;
}

export const query = graphql`
  fragment GraphBlock on WpAcfGraphBlock {
    AcfGraph {
      graphId
    }
  }
`;

const Chart = (props: ChartProps) => {
  const getChart = (graphId: string) => {
    switch (graphId) {
      case 'graph-1':
        return (
          <>
            <Chart1Wrapper />
          </>
        );
      case 'graph-2':
        return <Chart2Wrapper />;
      case 'graph-3':
        return <Chart3Wrapper />;
      case 'graph-4':
        return <Chart4Wrapper />;
      case 'graph-health-1':
        return <ChartHealth1Wrapper />;
      case 'graph-health-2':
        return <ChartHealth2Wrapper />;
      case 'graph-health-3':
        return <ChartHealth3Wrapper />;
      case 'graph-health-4':
        return <ChartHealth4Wrapper />;
    }
    return null;
  };

  return (
    <>
      {props.graphId === 'graph-1' ? <ChartQuestions /> : null}
      {props.graphId === 'graph-health-1' ? <ChartQuestionsHealth /> : null}
      <div className="chartcontainer">
        <div id={props.graphId} className="chartcontainer-anchor"></div>
        {getChart(props.graphId)}
      </div>
    </>
  );
};

export default Chart;
